const ferries = {
  ferry: "渡船", // translated
  ferries: "渡轮", // translated
  selectOriginPort: "选择始发港", // translated
  selectDestPort: "选择目的港", // translated
  continue: "继续", // translated
  viewTimetables: "查看时间表", // translated
  operator: "操作员", // translated
  cabin: "舱", // translated
  cabins: "客舱", // translated
  place: "地方", // translated
  places: "地点", // translated
  seat: "座位", // translated
  seats: "座位数", // translated
  seating: "座位", // translated
  deckSpace: "甲板空间", // translated
  compulsory: "强制性的", // translated
  departure: "离开", // translated
  total: "全部的", // translated
  back: "返回", // translated
  next: "下一个", // translated
  duration: "期间", // translated
  return: "返回", // translated
  prebook: "预售书", // translated
  travelInfo: "旅游信息", // translated
  book: "书", // translated
  adults: "成年人", // translated
  child: "孩子", // translated
  seniors: "老年人", // translated
  senior: "高级的", // translated
  to: "到", // translated
  passenger: "乘客", // translated
  details: "细节", // translated
  currencyForTickets: "这些门票的货币为", // translated
  seatsError: "乘客数量不等于容量。", // translated
  title: "标题", // translated
  firstName: "名", // translated
  lastName: "姓", // translated
  email: "电子邮件", // translated
  phone: "电话", // translated
  dateOfBirth: "出生日期", // translated
  placeOfBirth: "出生地", // translated
  groupLeader: "组长", // translated
  isRequired: "是必须的", // translated
  charactersOnly: "仅限角色", // translated
  latinCharactersAndSpacesOnly: "仅限拉丁字符和空格", // translated
  validEmail: "不是有效的电子邮件", // translated
  atLeastOneAdult: "至少需要 1 名成人。", // translated
  atLeastOneSenior: "至少需要 1 名高级人员。", // translated
  toastAlert: "请更正下表中的所有错误。", // translated
  backToFerriesList: "返回轮渡列表", // translated
  bestPrice: "最好的价钱", // translated
  fastest: "最快的", // translated
  beforeDeparture: "在出发前", // translated
  perPerson: "每人", // translated
  notAvailableForOnlineBooking: "不可在线预订", // translated
  hurryLimitedAvailability: "赶快！有限的可用率", // translated
  berth: "泊位", // translated
  berths: "泊位", // translated
  sumOfSelectionNotEqualToPersons: "您选择的总和不等于乘客人数", // translated
  attemptToBook: "您已尝试预订总计", // translated
  seatsWhenYouHave: "当你有座位时", // translated
  passengersTravelling: "旅行的乘客", // translated
  withReturn: "有往返票", // translated
  pleaseCorrectYourSelection: "请更正您的选择", // translated
  pleaseSelectUpTo: "请选择最多", // translated
  accommodationTypes: "住宿类型", // translated
  selectionPrices: "选择价格", // translated
  yourCurrentTicket: "您当前的门票类型是", // translated
  upgradeTo: "升级到", // translated
  wouldYouLikeToUpgrade: "您想升级您的门票类型吗？", // translated
  backToTicketTypes: "返回门票类型", // translated
  originPort: "始发港", // translated
  destinationPort: "目的端口", // translated
  outboundDate: "出境日期", // translated
  inboundDate: "入境日期", // translated
  passengers: "乘客", // translated
  hasReturn: "有回报", // translated
  passportNumber: "护照号", // translated
  passportExpiryDate: "护照有效期", // translated
  passportPlaceOfIssue: "护照签发地", // translated
  passportStartDate: "护照开始日期", // translated
  cityCode: "城市代码", // translated
};


export default ferries;
